<script lang="ts">
  import Wrapper from '$src/js/components/atoms/wrappers/Wrapper.svelte';
  import BaseModule from '$src/js/app/base/BaseModule';
  import Svg from '$src/js/components/_base/svg/Svg.svelte';
  import DomPurifyHtml from '$src/js/components/atoms/content/DomPurifyHTML.svelte';
  import { onMount } from 'svelte';

  const {
    isIphone,
    isAndroid,
  }: {
    isIphone: boolean;
    isAndroid: boolean;
  } = $props();

  let isVisible = $state(true);

  $effect(() => {
    if (!isVisible) {
      document.body.classList.remove('overflow-hidden');
    }
  });

  onMount(() => {
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      window.location.hash = '';
    }, 250);
  });
</script>

{#if isVisible}
  <div
    class="bg-surface-neutral-def-background fixed inset-0 z-2147483647 max-w-full overflow-auto pt-[64px]"
  >
    <Wrapper>
      <button
        class="btn-close fixed top-4 right-4"
        onclick={() => {
          isVisible = false;
        }}
      >
        <Svg icon="close" size="20" />
      </button>

      <div class="flex flex-col gap-8 pb-[56px]">
        <div class="flex flex-col gap-6">
          <h1 class="font-caps text-40asrem leading-[100%]">
            {BaseModule.getInstance().i18n.translate('addToHomescreen_overlay_title')}
          </h1>
          <div class="rich-content flex flex-col gap-4">
            <DomPurifyHtml
              html={BaseModule.getInstance().i18n.translate('addToHomescreen_overlay_description')}
            />
          </div>
        </div>

        <div class="flex flex-col gap-6">
          {#if isIphone}
            <h2 class="text-22asrem font-serif">
              {BaseModule.getInstance().i18n.translate(
                'addToHomescreen_overlay_description_iphone_title',
              )}
            </h2>
            <div class="rich-content flex flex-col gap-4">
              <DomPurifyHtml
                html={BaseModule.getInstance().i18n.translate(
                  'addToHomescreen_overlay_description_iphone',
                )}
              />
            </div>
          {/if}

          {#if isAndroid}
            <h2 class="text-22asrem font-serif">
              {BaseModule.getInstance().i18n.translate(
                'addToHomescreen_overlay_description_android_title',
              )}
            </h2>
            <div class="rich-content flex flex-col gap-4">
              <DomPurifyHtml
                html={BaseModule.getInstance().i18n.translate(
                  'addToHomescreen_overlay_description_android',
                )}
              />
            </div>
          {/if}
        </div>
      </div>
    </Wrapper>
  </div>
{/if}
